import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents, PrestoAppUtils } from 'presto-mini-apps-lib';
import { defaultOverlayStyle, ButtonHeight, PaymentType } from '../../constants/appState';
import TextInputWithLabel from '../../components/TextInputWithLabel';
import {
    term_loyaltyBalance,
    term_loyaltyValue,
    term_loyaltyPoints,
    term_loyaltyInput,
    term_loyaltyMinimum,
    term_loyaltyMaximum,
    term_loyaltyButtonNegative,
    term_loyaltyButtonPositive,
    term_loyaltyAccount,
    term_loyaltyInfoTnG
} from '../../constants/text';

class LoyaltyTypeInputModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showAmountError: false,
            minAmountError: false,
            maxAmountError: false,
            submitDisabled: true,
            calcPoints: null,
            formValue: {
                inputAmount: ''
            },
        };
    }

    componentDidUpdate(prevProps) {
        const {
            clearField,
            defaultVal
        } = this.props;

        if (prevProps.clearField !== clearField) {
            if (clearField) {
                if (!!defaultVal) {
                    this.onInputStateChangeHandler(defaultVal);
                } else {
                    this.setState({
                        minAmountError: false,
                        maxAmountError: false,
                        submitDisabled: true,
                        calcPoints: null,
                    });
                }
            }
        }
    }

    onInputStateChangeHandler = (input, elmName) => {
        const { loyaltyItem } = this.props;        
        const { minAmountError, maxAmountError, showAmountError } = this.state;

        var points = null;
        if (!!input && input.length > 0) {
            const val = parseFloat(input.replaceAll(',', ''));
            if (!isNaN(val) && +(val.toFixed(2)) === val) {
                const paymentAmount = Math.round(val * 100);
                points = Math.ceil(+paymentAmount / parseFloat(loyaltyItem.rate));
            }
        }

        if (!input || input.replaceAll(',', '').match(/^\d{1,}(\.\d{0,2})?$/)) {
            this.setState({
                loyaltyId: loyaltyItem.loyaltyId,
                formValue: {
                    ...this.state.formValue,
                    inputAmount: input
                },
                calcPoints: points,
                minAmountError: (!!points && !showAmountError ? false : minAmountError),
                maxAmountError: (!!points && !showAmountError ? false : maxAmountError),
                showAmountError: false,
                submitDisabled: !(!!input && input.length > 0)
            });
        }
    };

    checkForm = () => {
        const { formValue } = this.state;
        const { minAmount, maxAmount, onInputChange } = this.props;

        const input = formValue.inputAmount;
        if (!!input && input.length > 0) {
            const val = parseFloat(input.replaceAll(',', ''));;
            if (isNaN(val) || +(val.toFixed(2)) !== val) {
                this.setState({
                    minAmountError: true,
                    maxAmountError: false,
                    showAmountError: false,
                });
                return false;
            } else {
                const paymentAmount = Math.round(val * 100);
                if (paymentAmount < +minAmount) {
                    this.setState({
                        minAmountError: true,
                        maxAmountError: false,
                        showAmountError: true,
                    }, () => { onInputChange((minAmount / 100).toFixed(2)); });
                    return false;
                } else if (paymentAmount > +maxAmount) {
                    this.setState({
                        minAmountError: false,
                        maxAmountError: true,
                        showAmountError: true,
                    }, () => { onInputChange((maxAmount / 100).toFixed(2)); });
                    return false;
                } else {
                    this.setState({
                        minAmountError: false,
                        maxAmountError: false,
                        showAmountError: false,
                    });
                    return true;
                }
            }
        } else {
            this.setState({
                minAmountError: false,
                maxAmountError: false,
                showAmountError: false,
            });
            return false;
        }
    };

    onSubmitHandler = (e) => {
        e.preventDefault();
        const res = this.checkForm();
        if (res) {
            this.doSubmit();
        }
    };

    onRemoveHandler = (e) => {
        e.preventDefault();

        const { onRemove } = this.props;
        if (typeof onRemove === 'function') {
            onRemove();
        }
    }

    doSubmit = () => {
        const { formValue } = this.state;
        const { onSubmit } = this.props;

        const input = formValue.inputAmount;
        const paymentAmount = Math.round(parseFloat(input.replaceAll(',', '')) * 100);

        if (typeof onSubmit === 'function') {
            onSubmit(paymentAmount);
        }
    };

    render() {
        const {
            minAmountError,
            maxAmountError,
            submitDisabled,
            calcPoints,
        } = this.state;
        const {
            appState,
            clearField,
            defaultVal,
            isOpen,
            onClose,
            loyaltyItem,
            minAmount,
            maxAmount,
        } = this.props;

        return (
            <React.Fragment>
                <ModalOverlayWrapper className={[
                    'modal-overlay',
                    (!!isOpen ? ' show' : '')
                ].join('')}>
                    <div className="overlay" />
                    <ModalPanelWrapper className="popup-panel">
                        <div className="panel-control">
                            <button className="close-button" onClick={onClose} />
                        </div>
                        <div className="panel-header">
                            <div className="logo">{ !!loyaltyItem ? (loyaltyItem.logo) : '' }</div>
                        </div>
                        <div className="panel-body">
                            { !!loyaltyItem && !!loyaltyItem.memberId && loyaltyItem.loyaltyId !== PaymentType.GOREWARDS && (
                                <div className="loyalty-row">
                                    <div className="label">{term_loyaltyAccount}</div>
                                    <div className="value">{ !!loyaltyItem ? loyaltyItem.memberId : '' }</div>
                                </div>)
                            }
                            <div className="loyalty-row">
                                <div className="label">{term_loyaltyValue}</div>
                                <div className="value">{ !!loyaltyItem ? (appState.curCode.currency + PrestoAppUtils.convertToCurrency(loyaltyItem.balance / 100)) : '' }</div>
                            </div>
                            <div className="loyalty-row">
                                <div className="label">{term_loyaltyBalance(!!loyaltyItem ? loyaltyItem.unit : 'Points')}</div>
                                <div className="value">{ !!loyaltyItem ? (loyaltyItem.points + ' ' + term_loyaltyPoints) : '' }</div>
                            </div>
                        </div>
                        <div className="panel-body">
                            <div className="title">{term_loyaltyInput}</div>
                            <div className="amount">
                                <TextInputWithLabel
                                    inputName="loyaltyInputAmount"
                                    value={this.state.formValue.inputAmount}
                                    preText={ appState.curCode.currency }
                                    maxLength={10}
                                    inputStateChangeHandler={ this.onInputStateChangeHandler }
                                    clearField={ clearField }
                                    defaultVal={ defaultVal }
                                />
                                { !!calcPoints && <div className="additional-info">{calcPoints} {term_loyaltyPoints}</div> }
                            </div>
                        </div>
                        <div className="panel-action">
                            <PrestoAppComponents.Button
                                height={ ButtonHeight + 'px' }
                                bgColor={ PrestoAppTheme.colors.baseGreyLight }
                                onClick={ this.onRemoveHandler }
                            >{term_loyaltyButtonNegative}</PrestoAppComponents.Button>
                            <div className="devider"></div>
                            <PrestoAppComponents.Button
                                height={ ButtonHeight + 'px' }
                                className="confirm-button"
                                disabled={ submitDisabled }
                                onClick={ this.onSubmitHandler }
                            >{term_loyaltyButtonPositive}</PrestoAppComponents.Button>
                        </div>
                        <div className="panel-body">
                            {this.state.loyaltyId === PaymentType.GOREWARDS && (
						        <div className="info">
						            {term_loyaltyInfoTnG} 
						        </div>
						    )}
                            <div className={minAmountError ? 'info-error' : 'info'}>{term_loyaltyMinimum} { !!minAmount ? (appState.curCode.currency + PrestoAppUtils.convertToCurrency(+minAmount / 100)) : '' }.</div>
                            <div className={maxAmountError ? 'info-error' : 'info'}>{term_loyaltyMaximum} { !!maxAmount ? (appState.curCode.currency + PrestoAppUtils.convertToCurrency(+maxAmount / 100)) : '' }.</div>
                        </div>
                    </ModalPanelWrapper>
                </ModalOverlayWrapper>
            </React.Fragment>
        );
    }
}

export default LoyaltyTypeInputModal;


const commonBorderRadius = 6; // 6px
const commonBoxShadow = '0 1px 4px rgba(0, 0, 0, 0.1)';

const ModalOverlayWrapper = styled.div`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 100;
    
    & .overlay {
        ${defaultOverlayStyle}
    }
    
    &.show {
        display: flex;
    }
`;

const ModalPanelWrapper = styled.div`
    position: relative;
    width: 100%;
    border-radius: ${commonBorderRadius}px;
    box-shadow: ${commonBoxShadow};
    background-color: ${PrestoAppTheme.colors.white};
    border: solid ${PrestoAppTheme.colors.white} 1pt;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    
    & .panel-control {
        padding: 0;
        box-sizing: border-box;
        flex: 1;
        
        & .close-button {
            height: 0.75em;
            width: 0.75em;
            padding: 0px;
            margin: 0px;
            background: transparent url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGaADAAQAAAABAAAAGQAAAAB7O7VkAAABkElEQVRIDa2VwVGEMBSGIR6A244l2IB2IByhChvQsRVLoAJ3PHJBO3ArsAP1Bsyw4P8zGyYLCSSs78BLXpL/C8lL4nuwsix3TdPcB0HwkSTJL2OX2FRPMFBV1Vff93t4VMvdJYCiKO6kXl3Xr9QSCMS+7w/C8OywGURA27al1IN+zEmLLMv2qBxIpG0FaQAeVueFyy8oHIZhDLcZpANAL8cPPMN7Pj80/hbW8B3FW9ZpmMlnFEWYjDkZTIA0TR8GEXxGCAOuIBsAdc8gLiBbgBZiA3IBGCFLICHEU9d1b0qasnuu7gEDqs2WS2007NERgCul3yKA/RYh7KADMX6yVQD7DedEjtB5pi9m/oi246T9G+drOAeT+Ky6CuEmcw8wUl0iCl3bXkGLEF0W4YD+yKnaXkFGiA4A8Rw3wA280xWk3XgTQKapLhmWrqAZZA0gl8oFdAaxBbiCRogrwAU0QLYCbEHDGz95MjnW6iRLCA+s7uHTvvGnQU6AJRDatG/8JoAJJN942e5xX8bKPxRUvT+Ek5OUznWWswAAAABJRU5ErkJggg==") no-repeat scroll center center / contain;
            border: 0px none;
            cursor: pointer;
        }
    }

    & .panel-header {
        padding: 0.5rem 0;
        text-align: center;
        box-sizing: border-box;
        flex: 1;
        
        & .logo {
            margin: 0 auto;
            
            & img {
                width: 40%;
            }
        }
    }

    & .panel-body {
        padding: 0.5rem 0;
        text-align: left;
        box-sizing: border-box;
        flex: 3;
        font-weight: 300;
        font-size: 0.75rem;
        border-top: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
        
        & .loyalty-row {
            display: flex;
            width: 100%;
            justify-content: space-between;
            line-height: 1.25rem;
        
            & .label {
            }
            
            & .value {
                font-weight: 400;
            }
        }
        
        & .title {
        }
        
        & .info {
            color: #AAAAAA;
        }

        & .info-error {
            color: #FE8F27;
        }
        
        & .amount {
            
            & .additional-info {
                font-weight: 400;
                text-align: right;
            }
            
            & .error-message {
                line-height: 1.2rem;
            }
            
            & input {
                text-align: right;
            }
        }
    }

    & .panel-action {
        display: flex;
        padding: ${PrestoAppTheme.layout.smallGap} 0;
        text-align: right;
        box-sizing: border-box;
        justify-content: flex-end;
        flex: 1;
        bottom: 0;
        right: 0;
        opacity: 100%;

        & .devider {
            width: 2rem;
        }
    }
`;

